<template>
  <div class="hello">
    <h1 v-for="(typeinf,index) in msg" v-bind:key="index+rand">{{index+1}} :{{ typeinf }}</h1>
    <h1>{{ goat }}</h1>
    <h1>{{ this.getGoat }}</h1>
    <p>
      For a guide and recipes on how to configure / customize this project,<br>
      check out the
      <a href="https://cli.vuejs.org" target="_blank" rel="noopener">vue-cli documentation</a>.
    </p>
    <h3>Installed CLI Plugins</h3>
    <ul>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel" target="_blank" rel="noopener">babel</a></li>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint" target="_blank" rel="noopener">eslint</a></li>
    </ul>
    <h3>Essential Links</h3>
    <ul>
      <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
      <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
    </ul>
    <h3>Ecosystem</h3>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
      <Form />
  </div>
  
</template>

<script>

import Form from './FormComponent.vue';

export default {
  name: 'HelloWorld',
    components: {
    Form
  },
  data()
  {
    return{
      goat: "message app in hello component"
    }
    

  },
  props: {
    msg: 
    {
     type: Array,
      required: true
  },
  msgG:
  {
    type:Array,
    required: true
  }
},
created()
{
  alert(this.msgG[3]);
},
mounted()
{
  alert(this.msg[0]);
}
,
computed:
  {

    getGoat: function()
    {
      return this.goat+" computed";
    },

    rand()
    {
       var date = new Date();
      var timestamp = date.getTime();
      return Math.floor((Math.random() * 10)*timestamp);
     
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
